import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {AbstractColorPicker} from '../abstract-color-picker';

@Component({
  selector: 'app-color-dropdown',
  templateUrl: './color-dropdown.component.html',
  styleUrls: ['./color-dropdown.component.scss']
})
export class ColorDropdownComponent extends AbstractColorPicker implements AfterViewInit {

  @ViewChild('dropDownToggle', {static: false, read: ElementRef})
  dropdownToggle;

  @Input()
  colors: string[] = [];

  constructor() {
    super();
  }


  ngAfterViewInit() {
    jQuery(this.dropdownToggle.nativeElement).dropdown();
  }

  select(color: string): void {
    this.selectedColor = color;
    this.change();
  }
}
